enum MapTool {
  DROP_PIN = "dropPin",
  FIND_LEADS = "findLeads",
  LASSO = "lasso",
  PIN_LOCATION = "pinLocation",
  RULER = "ruler",
  TAKE_SNAPSHOT = "takeSnapshot",
}

export const MapToolAvailability = new Map<MapTool, MapTool[]>([
  [MapTool.LASSO, [MapTool.LASSO, MapTool.TAKE_SNAPSHOT]],
  [MapTool.RULER, [MapTool.RULER, MapTool.TAKE_SNAPSHOT]],
]);

export default MapTool;
